var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEolas(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 119.5,
    height: 119.5,
    rx: 59.75,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8796_327872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8381 59.4449L48.4085 52.0632L52.8878 47.6127L50.4335 45.1743C44.7938 39.7517 44.6466 30.8147 50.1044 25.2113C55.5621 19.6079 64.5572 19.4617 70.1969 24.8842C75.8367 30.3068 75.9838 39.2438 70.5261 44.8472C70.4184 44.9587 70.3076 45.0673 70.1969 45.1743L55.8381 59.4449ZM60.3175 31.3542C58.2727 31.3542 56.6163 33.0014 56.6163 35.033C56.6163 36.0337 57.0274 36.9922 57.754 37.6855L57.8298 37.7593L60.316 40.2295L62.8795 37.6855C64.3539 36.2779 64.4024 33.9509 62.9857 32.4845C62.2879 31.7626 61.3232 31.3542 60.316 31.3542H60.3175Z",
    fill: "url(#paint0_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8365 37.7645L57.7607 37.6906C57.031 36.9988 56.6184 36.0403 56.6215 35.0381C56.6215 34.8467 56.6367 34.6553 56.6655 34.4669L47.2988 29.394C44.9264 34.791 46.1793 41.0846 50.4402 45.1794L52.8945 47.6178L60.3242 40.2376L57.8365 37.766V37.7645Z",
    fill: "url(#paint1_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5273 35.0337C74.541 38.8587 72.9786 42.524 70.2027 45.175L55.8379 59.4472L48.4082 52.0654L60.3172 40.2332L62.8807 37.6877C64.3551 36.2831 64.4052 33.9592 62.9915 32.4943C62.9217 32.4219 62.8504 32.3526 62.7745 32.2878L67.0976 22.6318C71.6725 25.1035 74.5227 29.8614 74.5258 35.0352L74.5273 35.0337Z",
    fill: "url(#paint2_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9512 55.4455L68.3808 48.0638L73.0619 52.7162L75.5162 50.2777C80.9739 44.6743 89.969 44.5281 95.6088 49.9506C101.249 55.3732 101.396 64.3102 95.9379 69.9136C90.4802 75.517 81.4851 75.6632 75.8454 70.2407C75.7331 70.1337 75.6239 70.0236 75.5162 69.9136L60.9512 55.4455ZM89.4275 60.0979C89.4245 58.0663 87.7635 56.4221 85.7187 56.4266C84.7161 56.4281 83.7574 56.8335 83.0612 57.5509L82.9868 57.6263L80.5007 60.0979L83.0612 62.6404C84.4779 64.1053 86.8215 64.1535 88.2959 62.7459C89.0225 62.0526 89.4336 61.0941 89.4336 60.0934L89.4275 60.0979Z",
    fill: "url(#paint3_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9748 57.5947L83.0491 57.5194C83.7454 56.7945 84.7101 56.3845 85.7188 56.3876C85.9115 56.3876 86.1041 56.4026 86.2937 56.4313L91.3995 47.1265C85.9661 44.7709 79.6316 46.0157 75.5118 50.2492L73.062 52.6831L80.4871 60.0679L82.9748 57.5932V57.5947Z",
    fill: "url(#paint4_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7263 74.2121C81.8765 74.2256 78.1874 72.6733 75.5193 69.9153L60.9512 55.4457L68.3808 48.064L80.4976 60.1026L83.0612 62.6406C84.4749 64.1055 86.8139 64.1552 88.2883 62.7506C88.3611 62.6813 88.4309 62.6104 88.4961 62.5351L98.2148 66.8303C95.7271 71.3772 90.9353 74.209 85.7263 74.2106V74.2121Z",
    fill: "url(#paint5_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0385 60.6543L72.4667 68.036L67.9873 72.4865L70.4417 74.925C76.0799 80.3475 76.227 89.2846 70.7693 94.8865C65.3116 100.488 56.3165 100.635 50.6783 95.212C45.04 89.7895 44.8929 80.8524 50.3506 75.2505C50.4583 75.1405 50.5675 75.032 50.6783 74.925L65.0385 60.6543ZM60.5577 88.7466C62.6024 88.7466 64.2589 87.0993 64.2589 85.0677C64.2589 84.067 63.8478 83.1085 63.1212 82.4152L63.0454 82.3414L60.5577 79.8713L57.9942 82.4168C56.5198 83.8244 56.4727 86.1528 57.8895 87.6177C58.5873 88.3381 59.5505 88.7466 60.5562 88.7466H60.5577Z",
    fill: "url(#paint6_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0789 82.3353L63.1547 82.4092C63.8843 83.1009 64.2969 84.0594 64.2939 85.0617C64.2939 85.2531 64.2787 85.4445 64.2499 85.6328L73.6151 90.7057C75.9875 85.3088 74.7361 79.0152 70.4767 74.9204L68.0224 72.4819L60.5942 79.8622L63.0804 82.3338L63.0789 82.3353Z",
    fill: "url(#paint7_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3453 85.0662C46.3317 81.2412 47.894 77.576 50.6699 74.925L65.0347 60.6543L72.4644 68.036L60.5554 79.8683L57.9919 82.4137C56.5175 83.8183 56.4674 86.1423 57.8812 87.6072C57.9509 87.6795 58.0222 87.7489 58.0981 87.8137L53.775 97.4696C49.2001 94.998 46.3499 90.2401 46.3468 85.0647L46.3453 85.0662Z",
    fill: "url(#paint8_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9653 64.617L52.5357 71.9988L47.9365 67.4338L45.4822 69.8722C40.0245 75.4741 31.0294 75.6203 25.3912 70.1978C19.7529 64.7753 19.6058 55.8382 25.0635 50.2363C30.5212 44.6344 39.5163 44.4882 45.1545 49.9108C45.2653 50.0178 45.3745 50.1263 45.4822 50.2363L59.9638 64.617H59.9653ZM31.574 60.0475C31.574 62.0791 33.2319 63.7248 35.2766 63.7248C36.2839 63.7248 37.2486 63.3164 37.9464 62.5945L38.0207 62.5191L40.5068 60.0475L37.9464 57.499C36.5296 56.0341 34.1875 55.9859 32.7116 57.3935C31.985 58.0868 31.574 59.0453 31.574 60.046V60.049V60.0475Z",
    fill: "url(#paint9_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1044 62.5531L38.0301 62.6285C37.3338 63.3534 36.3691 63.7633 35.3604 63.7603C35.1677 63.7603 34.9751 63.7452 34.7855 63.7166L29.6797 73.0214C35.1116 75.3785 41.4461 74.1352 45.5675 69.9032L48.0218 67.4648L40.5936 60.083L38.1044 62.5546V62.5531Z",
    fill: "url(#paint10_linear_8796_327872)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2744 45.9264C39.1243 45.9128 42.8133 47.4651 45.4815 50.2231L59.9631 64.6158L52.5334 71.9976L40.5061 60.0463L37.9441 57.4978C36.5304 56.0329 34.1914 55.9832 32.717 57.3878C32.6442 57.4571 32.5744 57.528 32.5092 57.6033L22.7905 53.3111C25.2767 48.7642 30.0655 45.9324 35.2744 45.9279V45.9264Z",
    fill: "url(#paint11_linear_8796_327872)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8796_327872",
    x1: 60.3145,
    y1: 20.9115,
    x2: 60.3145,
    y2: 59.4449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8796_327872",
    x1: 51.4914,
    y1: 43.6979,
    x2: 54.1572,
    y2: 32.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8796_327872",
    x1: 51.3358,
    y1: 56.0065,
    x2: 70.5119,
    y2: 31.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8796_327872",
    x1: 80.443,
    y1: 45.9794,
    x2: 80.443,
    y2: 74.2149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8796_327872",
    x1: 76.9998,
    y1: 51.2966,
    x2: 87.8828,
    y2: 54.0091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8796_327872",
    x1: 64.3914,
    y1: 50.9968,
    x2: 89.176,
    y2: 70.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8796_327872",
    x1: 74.7678,
    y1: 79.9195,
    x2: 46.3506,
    y2: 79.9195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8796_327872",
    x1: 69.4209,
    y1: 76.4004,
    x2: 66.7566,
    y2: 87.2294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8796_327872",
    x1: 69.5368,
    y1: 64.092,
    x2: 50.3607,
    y2: 88.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8796_327872",
    x1: 40.5159,
    y1: 74.1705,
    x2: 40.5159,
    y2: 45.9381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#2A64F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A64F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8796_327872",
    x1: 44.0779,
    y1: 68.8558,
    x2: 33.1949,
    y2: 66.1418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0846A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1564FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8796_327872",
    x1: 56.5168,
    y1: 69.0723,
    x2: 31.8137,
    y2: 49.6234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0046AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#0066FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#0077FF",
    stopOpacity: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#00A3FF",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#00CCFF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#00C8FF",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00BEFF",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#00ADFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0094FF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#0076FF",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0066FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8796_327872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.87,
    height: 78.2725,
    fill: "white",
    transform: "translate(21.0645 20.9121)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEolas);
export default __webpack_public_path__ + "static/media/eolas.477f6092.svg";
export { ForwardRef as ReactComponent };